import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import blueCheckIcon from "../../../assets/blue-check.svg";
import checkIcon from "../../../assets/checkmark.svg";
import moneyIcon from "../../../assets/dinero.svg";
import educationIcon from "../../../assets/educacion.svg";
import incomesIcon from "../../../assets/ingresos-estables.svg";
import medalNomada from "../../../assets/medal-nomada.svg";
import otherIcon from "../../../assets/otro.svg";
import debtsIcon from "../../../assets/salir-deudas.svg";
import selectionIcon from "../../../assets/seleccion.svg";
import travelIcon from "../../../assets/viajar.svg";
import housingIcon from "../../../assets/vivienda.svg";
import { getQuestionsByPurposes, postResponsesPurposes } from "../../../services/mentoriaService";
import Loader from "../../../shared/src/components/atoms/loader/loader";
import MedalModal from "../../../shared/src/components/organisms/medal-modal/MedalModal";
import authContext from "../../../shared/src/contexts/authContext";
import { normalizeText } from "../../../shared/src/utils/stringManipulation";
import Button from "../../atoms/button/button";
import Input from "../../atoms/input/input";
import MultipleSelectCards from "../../molecules/multiple-select-cards/multipleSelectCards";
import QuestionWizard from "../question-wizard/questionWizard";
import "./propositos.scss";

const HEADEROFFSET = 75;

const cards = [
	{
		title: "Comprar vivienda",
		image: housingIcon,
		value: "Comprar vivienda",
	},
	{
		title: "Empezar a ahorrar",
		image: moneyIcon,
		value: "Empezar a ahorrar",
	},
	{
		title: "Salir de deudas",
		image: debtsIcon,
		value: "Salir de deudas",
	},
	{
		title: "Quiero estudiar",
		image: educationIcon,
		value: "Quiero estudiar",
	},
	{
		title: "Quiero viajar",
		image: travelIcon,
		value: "Quiero viajar",
	},
	{
		title: "Ingresos estables",
		image: incomesIcon,
		value: "Ingresos estables",
	},
	{
		title: "Otro",
		image: otherIcon,
		value: "Otro",
	},
]

const headerImages = [
	{
		image: selectionIcon,
		description: "Selecciona tus propositos"
	},
	{
		image: checkIcon,
		description: "Propositos listos"
	}
]

const Propositos = () => {
	const [selected, setSelected] = useState<Array<string>>([]);
	const [step, setStep] = useState(0);
	const [showQuestions, setShowQuestions] = useState<boolean>(false);
	const headerRef: any = useRef(null);
	const titleRef: any = useRef(null);
	const [propositosDataV2, setPropositosDataV2] = useState<any>([]);
	const [propositosQuestions, setPropositosQuestions] = useState<any>(null);
	const [loading, setLoading] = useState(false);
	const [questionsData, setQuestionsData] = useState<any>({})
	const [other, setOther] = useState('');
	const context = useContext(authContext);
	const navigate = useNavigate();

	const saveResponses = async () => {
		setLoading(true);
		try {
			return await postResponsesPurposes(propositosDataV2);

		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
			navigate('/formulario-inicial/');
		}
	}

	const handlePropositosContinue = async () => {
		if (selected.length === 0) return;
		setLoading(true);
		try {

			if (context) {
				const newSelected = [...selected]
				const idx = selected.indexOf("Otro");
				if (idx > -1) {
					const otherSanitized = normalizeText(other);
					newSelected[idx] = otherSanitized;
					cards[cards.length - 1].value = otherSanitized;
					setSelected(newSelected);
				}
				await getQuestionsByPurposes(JSON.stringify(newSelected)).then((response: any) => {

					if (response.data.data.length === 0) {
						setStep(step + 1);
						return;
					}

					let questions: any = []

					response?.data?.data.forEach((purpose: any) => {
						questions = [...questions, ...purpose.questions]
					});
					setPropositosQuestions(questions);
					setShowQuestions(true);
				}).catch((error) => {
					console.error(error);
					setShowQuestions(true);
					return;
				}).finally(() => {
					setLoading(false);
				})
			}
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
	}

	const setDataV2 = (value: any, field: any, type: any = null) => {
		let dummie = {
			idQuestion: field,
			idOption: null,
			openResponse: "",
		};
		let questionPos = propositosDataV2.findIndex(
			(item: any) => item.idQuestion === field
		);
		let parsedValue: any;
		try {
			parsedValue = JSON.parse(value);
		} catch (error) {
			parsedValue = value;
		}
		if (parsedValue?.id) {
			dummie.idOption = parsedValue.id;
			dummie.openResponse = parsedValue.name;
		} else {
			dummie.openResponse = value;
		}
		let processed = [...propositosDataV2];
		if (type === "checkbox") {
			let exist = processed.findIndex(
				(question) =>
					question.idQuestion === field &&
					question.idOption === parsedValue.id
			);
			if (exist !== -1) {
				// se filtra elemento por si ya existe
				processed.splice(exist, 1);
			} else {
				if (questionPos !== -1) {
					processed.splice(questionPos, 0, dummie)
				} else {
					processed.push(dummie);
				}
			}
		} else {
			if (questionPos !== -1) {
				processed[questionPos] = dummie;
			} else {
				processed.push(dummie);
			}
		}

		setPropositosDataV2(processed);
	};

	const setData = (value: any, field, type: any = null) => {
		setDataV2(value, field, type);

		let parsedValue;

		try {
			parsedValue = JSON.parse(value);
		} catch (error) {
			parsedValue = value;
		}

		const newFormData = { ...questionsData };
		if (!type) {
			newFormData[field] = parsedValue;
		} else if (type === "checkbox") {

			if (newFormData[field] === undefined) {
				newFormData[field] = [parsedValue];
			} else {
				const index = newFormData[field].findIndex((el) => el.id === parsedValue.id)
				if (index >= 0) {
					newFormData[field].splice(index, 1);
				} else newFormData[field] = [...newFormData[field], parsedValue];
			}
		}
		setQuestionsData(newFormData);
	}

	const nextFallback = () => {
		setShowQuestions(false);
		setStep(step + 1);
	}

	const prevFallback = () => {
		setShowQuestions(false);
	}

	const handlePropositosSave = () => {

		// Checkeo
		setStep(step + 1);
		headerRef?.current?.scrollIntoView();
	}

	const goBack = () => {
		setStep(0);
		setShowQuestions(true);
	}

	useEffect(() => {
		if (step === 1) {
			if (titleRef && titleRef.current) {
				const y = titleRef.current.getBoundingClientRect().top + window.pageYOffset - HEADEROFFSET;
				window.scrollTo({
					top: y
				});
			}
		} else {
			if (headerRef && headerRef.current)
				headerRef.current.scrollIntoView();
		}
	}, [step, showQuestions])

	if (loading) {
		return <Loader />
	}

	return (
		<div ref={titleRef} className="propositos-select-container">
			{(!showQuestions && step === 0) &&
				<header className="propositos-select-header">
					<img src={headerImages[step].image} alt={headerImages[step].description} />
					<div className="propositos-select-header__text">
						<h3>Selecciona un propósito</h3>
						<p>Inicia tu mentoría contándonos tu sueño</p>
					</div>
				</header>}
			{loading &&
				<div className="propositos-select__loading">
					{/* <Loading /> */}
				</div>}
			{(() => {
				switch (step) {
					case 0:
						return (
							<div className="propositos-select-questions-container">
								{
									showQuestions && propositosQuestions ?
										(
											<div className="propositos-select-form-container">
												<QuestionWizard
													questions={propositosQuestions}
													formData={questionsData}
													setData={setData}
													onMoveAfterFallback={nextFallback}
													onMovePreviousFallback={prevFallback}
													parentRef={null}
												/>	
											</div>
										) :
										<>
											<MultipleSelectCards
												selected={selected}
												setSelected={setSelected}
												cards={cards}
												disabled={showQuestions}
												limit={1}
												key="multiple-interact"
											/>
											{
												(selected.length > 0 && selected.includes("Otro")) &&
												<Input
													className="propositos-select-questions-container__other"
													type="text"
													placeholder="¿Cuál?"
													value={other}
													name={'Other'}
													handleChange={({ target: { value } }) => setOther(value)} />
											}
											<Button
												type="button"
												className="propositos-select-questions-container__button"
												text={showQuestions ? "Guardar" : "Continuar"}
												disabled={selected.length === 0 || (selected.length > 0 && selected.includes("Otro") && !other)}
												onClick={showQuestions ? handlePropositosSave : handlePropositosContinue}
											/>
										</>
								}
							</div>
						);
					case 1:
						return (
							<div className="propositos-select-questions-display">
								<div className="propositos-select-questions-display__header">
									<img src={blueCheckIcon} alt="Icono chulo" />
									<h2 className="propositos-select-questions-display__header__title">¡La información de tu propósito está lista!</h2>
									<p className="propositos-select-questions-display__header__description">Ahora que conocemos tu propósito, te invitamos a realizar tu diagnóstico financiero para acompañarte en el proceso de lograr eso que sueñas.</p>
								</div>
								<MultipleSelectCards
									selected={selected}
									setSelected={setSelected}
									cards={cards}
									limit={3}
									disabled={true}
									onlyShowSelected={true}
									key="multiple-display"
								/>
								<div className="propositos-select-questions-display-buttons">
									<Button
										type="button"
										gtmClass="secondary"
										className="propositos-select-questions-display-buttons__button"
										text="Realiza tu diagnóstico inicial"
										onClick={saveResponses}
									/>
									<Button
										type="button"
										gtmClass="primary"
										className="propositos-select-questions-display-buttons__button"
										text="Volver"
										onClick={goBack}
									/>
								</div>
								{createPortal(
									<MedalModal>
										<MedalModal.Icon element={<img className="medal-modal__icon" src={medalNomada} alt="Medalla Nomada" />} />
										<MedalModal.Title>¡Felicidades!</MedalModal.Title>
										<p><b>¡Desbloqueaste la medalla Nómada financiero!</b></p>
										<p>Has dado tus primeros pasos en el mundo de las finanzas personales, tu disposición te llevará lejos en este emocionante viaje financiero.</p>
									</MedalModal>,
									document.body
								)}
							</div>
						);
					default:
						return null;
				}
			})()}
		</div>
	);
};

export default Propositos;
